<template >
  <v-layout justify-center>
    <v-flex xs0 sm0 md1>
    </v-flex>
    <v-flex xs12 sm12 md10>
      <v-app id="app">
      <v-v-app-bar color="white" fixed app>
        <v-toolbar v-if="$route.path != '/'">
          <!-- Colonna Sinistra -->
          <div class="toolbar-section-left">
            <v-app-bar-nav-icon color="#234a98"
              @click.stop="drawer = !drawer" >
            </v-app-bar-nav-icon>
          </div>
          
          <!-- Colonna Centrale - Logo -->
          <div class="toolbar-section-center">
            <img height="50px" src="./assets/YT_logo_png.png" />
          </div>
          
          <!-- Colonna Destra -->
          <div class="toolbar-section-right">
            <language-selector class="mr-4"></language-selector>
            <v-avatar class="mr-4">
              <v-img src="./assets/blank-profile-picture-973460_1280.png" width="20%" />
            </v-avatar>
            <h4 class="mt-0"> {{ displayName }}</h4>
          </div>
        </v-toolbar>
        </v-v-app-bar>
        

        <v-navigation-drawer style="background: linear-gradient(rgba(0, 156, 168, 1), rgba(33, 58, 143, 1));" width="360" v-model="drawer" app left temporary v-if="$route.path != '/'">
          <v-list nav dense expand>
            <!-- Menu dinamico generato dalle categorie -->
            <div v-for="(category, catIndex) in menuCategories" :key="'category-' + catIndex">
              <v-list-group 
                :prepend-icon="category.icon"
                no-action
                color="white"
                v-model="openCategories[catIndex]"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title 
                      class="menu-category-title"
                      :class="{ 'menu-category-title--preserve-case': category.name === 'DASHBOARDS' }"
                    >
                      {{ category.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="(item, i) in category.items"
                  :key="'item-' + catIndex + '-' + i"
                  @click="item.MailTo != 1 ? Redirect(item.route != '' ? item.route : item.href, false) : MailTo(item.Email)"
                  :disabled="item.disabled"
                  class="menu-subitem"
                  :class="{ 'menu-active': isActiveRoute(item) }"
                >
                  <v-list-item-content>
                    <v-list-item-title 
                      class="menu-subitem-title"
                      :style="isActiveRoute(item) ? 'color: #FFFFFF; font-weight: bold;' : 'color: #BFCCE4'"
                    >
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>

              <v-divider 
                v-if="catIndex < menuCategories.length - 1 || standaloneItems.length > 0"
                class="menuDivider" 
                color="white"
              ></v-divider>
            </div>

            <!-- Voci standalone (es. Logout) -->
            <div v-if="standaloneItems.length > 0">
              <v-list-item
                v-for="(item, i) in standaloneItems"
                :key="'standalone-' + i"
                @click="Redirect(item.route != '' ? item.route : item.href, true)"
                :disabled="item.disabled"
                class="menu-standalone-item"
              >
                <v-list-item-icon>
                  <v-icon color="white">{{ item.icon || 'mdi-logout-variant' }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title 
                    class="menu-standalone-title"
                  >
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list>
        </v-navigation-drawer>
          <router-view id="makeMeBlue"/>
      </v-app>
    </v-flex>
    <v-flex xs0 sm0 md1>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import LanguageSelector from './components/LanguageSelector.vue'
  export default {
  name: 'App',
  components: {
    LanguageSelector
  },
  data(){
    return{
      displayName: '',
      avatar: '',
      menuCategories: [],
      standaloneItems: [],
      drawer: true,
      openCategories: [], // Array per tracciare le categorie aperte
    }
  },
  created(){
    this.$vuetify.theme.themes.light.primary = '#234a98'
    axios.defaults.headers.common["x-api-key"] = "19ef07bf8e620d48.a38898e8-fd15-4523-9b87-6d63b6809c20";
    this.$on("welcome", () => {
      this.loadMenu();
    });
  },
  methods: {
    MailTo(email){
      window.location.href = 'mailto:' + email;
    },
    Redirect(_path, closeDrawer = false){
      this.$router.push({ path: _path });
      // Chiude il drawer solo se esplicitamente richiesto (es. per Logout)
      if (closeDrawer) {
        this.drawer = false;
      }
    },
    loadMenu(){
      this.avatar = this.$store.state.avatar;
      this.displayName = this.$store.state.displayName;
      
      console.log('Loading menu...', this.$store.state.menu);
      
      // Se il menu è vuoto o non esiste, non fare nulla
      if (!this.$store.state.menu || this.$store.state.menu.length === 0) {
        console.log('Menu vuoto nello store');
        return;
      }
      
      // Configurazione delle categorie con icone, titoli e ordine
      const categoryConfig = {
        'SENSORS': { icon: 'mdi-access-point-network', order: 1, title: 'SENSORS' },
        'SENSOR': { icon: 'mdi-access-point-network', order: 1, title: 'SENSORS' },
        'ALERTS': { icon: 'mdi-alert', order: 2, title: 'ALERTS' },
        'ANALYTICS': { icon: 'mdi-chart-line', order: 3, title: 'ANALYTICS' },
        'MY_DASHBOARD': { icon: 'mdi-view-dashboard', order: 4, title: 'MY DASHBOARD' },
        'MYDASHBOARD': { icon: 'mdi-view-dashboard', order: 4, title: 'MY DASHBOARD' },
        'DASHBOARDS': { icon: 'mdi-monitor-dashboard', order: 5, title: 'MY KPIs' },
        'MANAGEMENT': { icon: 'mdi-cog', order: 6, title: 'MANAGEMENT' },
        'MANAGE': { icon: 'mdi-cog', order: 6, title: 'MANAGEMENT' },
        'SUPPORT': { icon: 'mdi-help-circle', order: 7, title: 'SUPPORT' }
      };
      
      // Raggruppa gli items per categoria
      const categoriesMap = {};
      const standaloneItems = [];
      
      this.$store.state.menu.forEach(item => {
        const category = item.category;
        
        // STANDARD items vanno fuori dalle categorie (es. Logout)
        if (category === 'STANDARD') {
          standaloneItems.push(item);
          return;
        }
        
        const config = categoryConfig[category] || { icon: 'mdi-circle', order: 999, title: category };
        
        if (!categoriesMap[category]) {
          categoriesMap[category] = {
            name: category,
            title: config.title,
            icon: config.icon,
            order: config.order,
            items: []
          };
        }
        
        categoriesMap[category].items.push(item);
      });
      
      // Converti in array e ordina per ordine - filtra le categorie vuote
      this.menuCategories = Object.values(categoriesMap)
        .filter(cat => cat.items.length > 0)
        .sort((a, b) => a.order - b.order);
      
      this.standaloneItems = standaloneItems;
      
      // Inizializza l'array delle categorie aperte - forza tutte chiuse usando Vue.set
      this.openCategories = [];
      this.menuCategories.forEach((category, index) => {
        this.$set(this.openCategories, index, false);
      });
      
      // Apri automaticamente la categoria che contiene la route attiva SOLO se non siamo in /welcome
      if (this.$route.path !== '/welcome') {
        this.menuCategories.forEach((category, index) => {
          const hasActiveItem = category.items.some(item => this.isActiveRoute(item));
          if (hasActiveItem) {
            this.$set(this.openCategories, index, true);
          }
        });
      }
      
      console.log('Menu categories:', this.menuCategories);
      console.log('Standalone items:', this.standaloneItems);
      console.log('Open categories:', this.openCategories);
    },
    isActiveRoute(item) {
      const currentPath = this.$route.path;
      const itemRoute = item.route || '';
      
      // Controllo esatto per il path
      if (currentPath === itemRoute) return true;
      
      // Controllo per sottopercorsi
      const currentParts = currentPath.split('/').filter(p => p);
      const itemParts = itemRoute.split('/').filter(p => p);
      
      if (itemParts.length >= 2) {
        return currentParts[0] === itemParts[0] && 
               currentParts[1] === itemParts[1];
      }
      
      return currentParts[0] === itemParts[0];
    }

  },
  watch: {
    $route(to, from) {
      if(to.path == "/welcome" && from.path == "/"){
        this.loadMenu();
      }
    },
    '$store.state.menu': function(val){
      if(val.length != 0)
        this.loadMenu();
    },
    
  }

}
</script>
<style lang="scss">

@font-face {
  font-family: "Montserrat";
  src: local("Montserrat"),
  url("./font/Montserrat-Regular.ttf") format("truetype");
}

.text_youtissue input{
  color: #234a98 !important;
}
.v-slider__thumb{
  cursor:pointer;
  height:42px;
  width:42px;
}
#app {
  font-family: Montserrat;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #234a98;
  // background: url(./assets/test_sfondo.png) no-repeat left center fixed !important;
  // background-size: cover;
}
v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed v-text-field--outlined{
  color: #234a98;
}
h1,h2,h3,h4,h5,h6,p{
  color: #234a98;
}
.v-card__text{
  color: #234a98;
}
.v-label{
  font-weight:bolder;
}
#input{
  color:#234a98;
}
.v-input{
  color: #234a98;
}
.v-input__slot{
  color: #234a98;
}
.v-list-item--link::before {
  color: #234a98
}
.vs-dropdown{
  color: #234a98;
}
.v-list-item__title{
  font-weight: bold;
  text-align: left;
}
v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined{
  color: #234a98;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #213A8F;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#makeMeBlue .v-label {
  color:#234a98 !important;
}
// #makeMeBlue .v-icon {
//   color: #234a98 !important;
// }
#makeMeBlue .v-text-field--outlined fieldset {
  border: #234a98 1px solid !important; 
}
.menuDivider{
  border: 1px solid !important;
  color: #FFFFFF !important;
}
.v-text-field input{
  color: #234a98 !important;
}
.mdi-calendar::before{
  color: #234a98 !important;
}
.no-wrap {
  white-space: normal !important;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

/* Layout toolbar a 3 colonne per mantenere il logo centrato */
.v-toolbar__content {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  width: 100% !important;
}

.toolbar-section-left,
.toolbar-section-right {
  flex: 1;
  display: flex;
  align-items: center;
}

.toolbar-section-left {
  justify-content: flex-start;
}

.toolbar-section-center {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.toolbar-section-right {
  justify-content: flex-end;
}

/* Stili per il menu espandibile */
.v-list-group__header {
  padding-left: 12px !important;
  padding-right: 8px !important;
}

.menu-category-title {
  color: white !important;
  font-size: 14px !important;
  font-weight: bold !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap !important;
}

.menu-category-title--preserve-case {
  text-transform: none !important;
}

.menu-subitem {
  padding-left: 88px !important;
  min-height: 40px !important;
}

.menu-subitem-title {
  font-size: 12px !important;
  font-weight: bold !important;
  white-space: normal !important;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.menu-active {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-left: 4px solid #FFFFFF;
}

/* Colore delle icone del menu */
.v-list-group__header .v-icon {
  color: white !important;
}

/* Freccia di espansione bianca */
.v-list-group__header__append-icon .v-icon {
  color: white !important;
}

/* Stili per le voci standalone (es. Logout) */
.menu-standalone-item {
  padding-left: 12px !important;
  min-height: 48px !important;
}

.menu-standalone-item .v-list-item__icon {
  margin-right: 32px !important;
}

.menu-standalone-title {
  color: white !important;
  font-size: 14px !important;
  font-weight: bold !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap !important;
  text-align: left;
}

// .v-list-item__title, .v-list-item__subtitle{
//   color: #234a98 !important;
// }
</style>
